export function getLocalStorageUser() {
	try {
		return JSON.parse(localStorage.getItem('user'));
	} catch (err) {
		return null;
	}
}
